import {Component, OnInit, TemplateRef} from '@angular/core';
import {base64ToFile, Dimensions, ImageCroppedEvent} from 'ngx-image-cropper';
import {ApiService} from '../../core/http/api.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../environments/environment';
import {Location} from '@angular/common';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-nft-create-collection',
    templateUrl: './nft-create-collection.component.html',
    styleUrls: ['./nft-create-collection.component.css'],
    standalone: false
})
export class NftCreateCollectionComponent implements OnInit {

  collection = {
    title: '',
    description: '',
    thumbnail: '',
    category: '',
    entity: ''
  };

  isCollectionCreated = false;
  isError = false;
  errMessage = '';
  categories = [];
  categoryList = [];
  entities = [];

  // IMAGE UPLOAD
  modalRef: BsModalRef;
  imageChangedEvent: any = '';
  croppedFile: any;
  aspectRatio = 1;
  uploading = false;

  constructor(private api: ApiService,
              private modalService: BsModalService,
              private location: Location,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.getEntityCategories();
  }

  categoryChange(): void {
    this.api.getEntitiesByCategory(this.collection.category).subscribe(res => {
      this.entities = Array.isArray(res) ? res : [];
    });
    this.collection.entity = '';
  }

  handleClickUpload(): void {
    const ele = document.getElementById('dp');
    if (!!ele) {
      ele.click();
    }
  }

  createCollection(): void {
    this.api.newNftCollection(this.collection).subscribe(res => {
      this.location.back();
    }, err => this.toastr.error(err.error.status));
  }

  getEntityCategories(): void {
    this.api.getEntityCategories().subscribe(res => {
      this.categories = res.categories;
    });
  }

  // IMAGE CROPPER

  fileChangeEvent(event: any, template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template);
    this.aspectRatio = 1;
    this.imageChangedEvent = event;
  }

  uploadImage(event): void{
    this.uploading = true;
    // const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.croppedFile);
    reader.onload = () => {
      this.api.uploadImage({file: reader.result}).subscribe(res => {
        this.collection.thumbnail = res.response.url;
        this.uploading = false;
      }, err => {
        this.uploading = false;
      });
    };
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedFile = new File([base64ToFile(event.base64)], `${Date.now()}.png`);
  }

  loadImageFailed(): void {
    // this.toastr.error('Image Load failed!');
  }

}
